import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";
import { Sprig } from "./Botanical";

export const FinalCta = () => (
    <section
        className="grain relative overflow-hidden bg-plum py-20 text-center sm:py-28"
        data-testid="final-cta-section"
    >
        <div
            aria-hidden
            className="pointer-events-none absolute left-1/2 top-0 h-[26rem] w-[26rem] -translate-x-1/2 rounded-full bg-burgundy/50 blur-3xl"
        />
        <Sprig className="pointer-events-none absolute left-8 bottom-10 hidden w-16 -rotate-12 text-gold/20 sm:block" />
        <Sprig className="pointer-events-none absolute right-8 top-10 hidden w-16 rotate-[24deg] text-gold/20 sm:block" />

        <div className="relative z-10 mx-auto max-w-3xl px-5 sm:px-8">
            <Reveal>
                <h2 className="font-serif text-2xl font-medium leading-snug text-cream sm:text-3xl lg:text-5xl">
                    What If 5 Days Could Help You See Your Relationship{" "}
                    <em className="italic text-gold">Differently?</em>
                </h2>
            </Reveal>
            <Reveal delay={0.1}>
                <p className="mx-auto mt-7 max-w-lg text-base leading-relaxed text-cream/80 sm:text-lg">
                    You don&rsquo;t need to solve everything today. Just start by understanding the pattern.
                </p>
                <p className="mx-auto mt-4 font-sans font-semibold text-cream sm:text-lg">
                    Your 5-Day Husband Reset starts here.
                </p>
            </Reveal>
            <Reveal delay={0.2}>
                <div className="mt-10" data-testid="final-cta-wrap">
                    <CtaButton testId="final-cta-button" variant="gold" className="px-9 py-5 text-sm">
                        Get the Guide &mdash; &#8377;49
                    </CtaButton>
                </div>
                <p className="mt-5 font-sans text-[0.7rem] font-medium uppercase tracking-[0.18em] text-cream/70" data-testid="final-cta-microcopy">
                    Instant Digital PDF <span className="mx-1.5 text-gold">&bull;</span> Start Today
                </p>
            </Reveal>
        </div>
    </section>
);

export default FinalCta;
